import { render } from "./ZoneWizardRegisterTemplate.vue?vue&type=template&id=918ff0e2&scoped=true"
import script from "./ZoneWizardRegisterTemplate.vue?vue&type=script&lang=js"
export * from "./ZoneWizardRegisterTemplate.vue?vue&type=script&lang=js"

import "./ZoneWizardRegisterTemplate.vue?vue&type=style&index=0&id=918ff0e2&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-918ff0e2"]])

export default __exports__